import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Checkout from "../Checkout/Checkout";
import Pay from "../Pay/Pay";
import FollowUp from "../FollowUp/FollowUp";
import UserInfo from "./UserInfo/UserInfo";
import Orders from "./Orders/Orders";
import Support from "./Support/Support";
import NewTicket from "./Support/NewTicket/NewTicket";
import Ticket from "./Support/Ticket/Ticket";
import withRouter from "../withRouter/withRouter";

import "./Costumer.css";
import Favorites from "./Favorites/Favorites";

class Costumer extends Component {
    constructor(props) {
        super(props);
        this.menu_on_click = this.menu_on_click.bind(this);
    }
    state = {
        selected: this.props.router.location.pathname.replace("/costumer/", ""),
    };

    componentDidMount() {
        let { costumer } = this.props;
        costumer &&
            !costumer.signed &&
            this.setState({ navigate: <Navigate to='/register/costumer' /> });
    }

    componentDidUpdate() {
        let { costumer } = this.props;
        // costumer &&
        //     !costumer.signed &&
        //     this.setState({ navigate: <Navigate to="/register/costumer" /> });

        let curPath = this.props.router.location.pathname.replace(
            "/costumer/",
            ""
        );
        let { selected: prevPath } = this.state;
        if (curPath !== prevPath) {
            this.setState({ selected: curPath });
        }
    }

    menu_on_click(ev) {
        this.setState({ selected: ev.target.name });
    }

    render() {
        let { selected, navigate } = this.state;
        let { toast, connection, deleteFromCart, costumer } = this.props;

        return (
            <div className='CostumerComponent'>
                {navigate}
                <div className='menu'>
                    <a
                        href='/costumer/orders'
                        onClick={this.menu_on_click}
                        name='orders'
                        className={selected === "orders" ? "selected" : ""}
                    >
                        <i className='fa-solid fa-clock-rotate-left'></i>
                        سفارش ها
                    </a>
                    <a
                        href='/costumer/checkout'
                        onClick={this.menu_on_click}
                        name='checkout'
                        className={selected === "checkout" ? "selected" : ""}
                    >
                        <i className='fa-solid fa-cart-shopping'></i>
                        سبد خرید
                    </a>

                    <a
                        href='/costumer/favorites'
                        onClick={this.menu_on_click}
                        name='favorites'
                        className={selected === "favorites" ? "selected" : ""}
                    >
                        <i className='ri-star-fill'></i>
                        علاقه مندی ها و اعلان ها
                    </a>
                    <a
                        href='/costumer/support'
                        onClick={this.menu_on_click}
                        name='support'
                        className={selected === "support" ? "selected" : ""}
                    >
                        <i className='fa-solid fa-headset'></i>
                        درخواست پشتیبانی
                    </a>
                    <a
                        href='/costumer/info'
                        onClick={this.menu_on_click}
                        name='info'
                        className={selected === "info" ? "selected" : ""}
                    >
                        <i className='fa-regular fa-user'></i>
                        مشخصات کاربر
                    </a>
                    <a
                        href='/costumer/follow-up'
                        onClick={this.menu_on_click}
                        name='follow-up'
                        className={selected === "follow-up" ? "selected" : ""}
                    >
                        <i className='fa-solid fa-truck-fast'></i>
                        پیگیری سفارش
                    </a>
                    <a
                        href='/costumer/pay/offline'
                        onClick={this.menu_on_click}
                        name='pay/offline'
                        className={selected === "pay/offline" ? "selected" : ""}
                    >
                        <i className='fa-solid fa-credit-card'></i>
                        ثبت فیش واریز
                    </a>
                </div>
                <div className='page'>
                    <Routes>
                        <Route
                            path='orders'
                            element={
                                <Orders
                                    toast={toast}
                                    connection={connection}
                                    costumer={costumer}
                                />
                            }
                        />
                        <Route
                            path='checkout'
                            element={
                                <Checkout
                                    toast={toast}
                                    connection={connection}
                                    deleteFromCart={deleteFromCart}
                                    cart={costumer.cart}
                                    clear_cart={this.props.clear_cart}
                                />
                            }
                        />
                        <Route
                            path='favorites'
                            element={
                                <Favorites
                                    costumer={costumer}
                                    connection={connection}
                                    toast={toast}
                                />
                            }
                        />

                        <Route
                            path='support'
                            element={
                                <Support
                                    costumer={costumer}
                                    connection={connection}
                                    toast={toast}
                                />
                            }
                        />

                        <Route
                            path='support/new'
                            element={
                                <NewTicket
                                    costumer={costumer}
                                    connection={connection}
                                    toast={toast}
                                />
                            }
                        />

                        <Route
                            path='support/:id'
                            element={
                                <Ticket connection={connection} toast={toast} />
                            }
                        />

                        <Route
                            path='info'
                            element={
                                <UserInfo
                                    costumer={costumer}
                                    connection={connection}
                                    toast={toast}
                                />
                            }
                        />

                        <Route
                            path='follow-up'
                            element={
                                <FollowUp
                                    toast={toast}
                                    costumer={costumer}
                                    connection={connection}
                                />
                            }
                        />

                        <Route
                            path='follow-up/:id'
                            element={
                                <FollowUp
                                    toast={toast}
                                    costumer={costumer}
                                    connection={connection}
                                />
                            }
                        />

                        <Route
                            path='pay/:method/:id'
                            element={
                                <Pay
                                    toast={this.toast}
                                    costumer={costumer}
                                    connection={connection}
                                />
                            }
                        />

                        <Route
                            path='pay/:method'
                            element={
                                <Pay
                                    toast={this.toast}
                                    costumer={costumer}
                                    connection={connection}
                                />
                            }
                        />

                        <Route
                            path='pay/:method/:id/:mobile'
                            element={
                                <Pay
                                    toast={this.toast}
                                    costumer={costumer}
                                    connection={connection}
                                />
                            }
                        />

                        <Route path='*' element={<Navigate to='orders' />} />
                    </Routes>
                </div>
            </div>
        );
    }
}

export default withRouter(Costumer);
